import React, { useState } from 'react';
import { saveAs } from './FileSaver';

const Api = require('./Config');

const getAllHl7Reviews = async ({ from_date, till_date, filters }) => {
  if (from_date == null || till_date == null) {
    alert('Valid Date Range required!');
    return;
  }

  return await Api.getAllHl7Reviews({ p_from_date: from_date, p_till_date: till_date, filter: filters }).catch(
    (error) => {
      alert('' + error);
      console.log(error);
    }
  );
};

const EncounterCSV = ({ from_date, till_date, filters }) => {
  const [isLoading, setIsLoading] = useState(false);

  const getCSVLine = (row, answer, officeName) => {
    const hasAnswer = answer.length > 0;

    const data = [
      row.app_id,
      officeName,
      row.patient_ref,
      row.patient_ini,
      row.t_code,
      row.group_name,
      row.doc_ref,
      row.journey_name,
      hasAnswer ? answer[0] : 'N/A',
      hasAnswer ? answer[1] : 'N/A',
      hasAnswer ? answer[2] : 'N/A',
      row.need_help_answer,
      Api.getDateFormat(row.t_created_date, true),
      Api.getDateFormat(row.t_deleted_date, true),
      row.current_status,
      row.note,
      // Value for "Message Sent" to be added here
    ];

    return data.join(',');
  };

  const doCsv = async () => {
    setIsLoading(true);
    let csv = 'Run Date,' + Api.getDateFormat(new Date(), false);
    let { encounters } = await getAllHl7Reviews({ from_date, till_date, filters });

    csv += '\r\n';
    csv +=
      'Date Range,' +
      Api.getDateFormat(new Date(Date.parse(from_date)), false) +
      ',' +
      Api.getDateFormat(new Date(Date.parse(till_date)), false);
    csv += '\r\n';
    csv += '\r\n';

    const headings = [
      'App Code ',
      'Provider Office',
      'Patient Id',
      'Patient initial',
      't-code',
      'Group',
      'Physician',
      'Journey',
      'Question',
      'answer',
      'Ind',
      'Help',
      'created',
      'Transferred',
      'Status',
      'note',
      // 'Message Sent'
    ];

    csv += headings.join(',');
    csv += '\r\n';
    const officeName = localStorage.getItem('username') || '';

    for (let counter = 0; counter < encounters.length; counter += 1) {
      const row = encounters[counter];
      const allAnswers = row.allAnswers;
      if (allAnswers.length > 0) {
        for (const answer of allAnswers) {
          const line = getCSVLine(row, answer, officeName);
          csv += `${line}\r\n`;
        }
      } else {
        const line = getCSVLine(row, [], officeName);
        csv += `${line}\r\n`;
      }
    }
    const blob = new Blob([csv], { type: 'text/plain;charset=utf-8' });
    saveAs(blob, `${new Date()} - review - report.csv`);
    setIsLoading(false);
  };

  return (
    <button onClick={doCsv} className="btn btn-primary" type="button" disabled={isLoading}>
      <i className="fa fa-download " style={{ marginRight: 5 }} />
      CSV
    </button>
  );
};

export default EncounterCSV;
